/**
 * Regex-based chief complaint hints (Phase 1 / Phase 3 Pass 1).
 * Ordered for deterministic multi-match scans; do not rely on first-hit-only here.
 */

/** @type {{ id: string, patterns: RegExp[] }[]} */
export const CHIEF_COMPLAINT_RULES = [
  { id: 'cc_chest_pain', patterns: [/chest\s*pain/i, /\bacs\b/i, /substernal/i, /angina/i] },
  { id: 'cc_dyspnea', patterns: [/shortness\s+of\s+breath/i, /\bsob\b/i, /dyspnea/i, /can'?t\s+breathe/i, /trouble\s+breathing/i] },
  { id: 'cc_abdominal_pain', patterns: [/abdominal\s*pain/i, /belly\s*pain/i, /stomach\s*pain/i] },
  { id: 'cc_headache', patterns: [/headache/i, /migraine/i, /\bha\b/i] },
  { id: 'cc_syncope', patterns: [/syncope/i, /passed\s+out/i, /faint(ed|ing)?/i, /dizz(y|iness)?/i, /lightheaded/i] },
  {
    id: 'cc_altered_mental_status',
    patterns: [/altered\s+mental/i, /confus(ed|ion)/i, /encephalopath/i, /\bams\b/i],
  },
  { id: 'cc_back_pain', patterns: [/back\s*pain/i, /lower\s+back/i, /lumbar\s*pain/i] },
  { id: 'cc_fever', patterns: [/fever/i, /febrile/i, /temperature\s*(of)?\s*\d{3}/i] },
  { id: 'cc_weakness', patterns: [/weakness/i, /feel\s+weak/i, /unable\s+to\s+move/i, /hemiparesis/i] },
  { id: 'cc_seizure', patterns: [/seizure/i, /convulsion/i, /postictal/i] },
  { id: 'cc_trauma_blunt', patterns: [/blunt\s*trauma/i, /mvc\b/i, /car\s+accident/i, /fall\s+from/i] },
  { id: 'cc_vaginal_bleeding', patterns: [/vaginal\s+bleeding/i, /pv\s+bleed/i] },
  { id: 'cc_palpitations', patterns: [/palpitation/i, /heart\s+racing/i, /pounding\s+heart/i] },
  { id: 'cc_sore_throat', patterns: [/sore\s+throat/i, /odynophagia/i, /pharyngitis/i] },
  { id: 'cc_leg_pain_swelling', patterns: [/leg\s+swelling/i, /calf\s+pain/i, /\bdvt\b/i] },
];

/**
 * All CC ids that match the text (multiple patterns per id collapse to one hit).
 * @param {string} text
 * @returns {string[]}
 */
export function matchAllChiefComplaintIdsFromText(text) {
  if (!text || typeof text !== 'string') return [];
  const hits = new Set();
  for (const rule of CHIEF_COMPLAINT_RULES) {
    for (const re of rule.patterns) {
      if (re.test(text)) {
        hits.add(rule.id);
        break;
      }
    }
  }
  return [...hits];
}
